



















import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component
export default class PostCommentField extends Vue {
  public $refs!: {
    form: any,
  };

  @Prop({type: Object, default: {}}) private post!: any;
  @Prop({type: Function, default: () => ({})}) private callback!: any;
  private commentText: string = '';
  private loading: boolean = false;

  @Action('user/comments/create') private storePostComment!: ({post, commentText}) => Promise<boolean>;
  @Action('user/posts/readOne') private readPost!: ({id}) => Promise<boolean>;

  @Getter('common/rules/all') private rules!: any;

  private async postComment(e) {
    e.preventDefault();
    if (this.$refs.form.validate()) {
      try {
        this.loading = true;
        const succ = await this.storePostComment({post: this.post, commentText: this.commentText});
        if (!succ) {
          // TODO: add translation
          throw new Error('Error while creating comment');
        }
        const post = await this.readPost(this.post);
        this.$emit('update', post);
        this.callback(this.commentText);
        this.commentText = '';
        this.$refs.form.resetValidation();
        this.loading = false;
      } catch (ex) {
        this.loading = false;
      }
    }
  }
}
